/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonaType } from './PersonaType';
import {
    PersonaTypeFromJSON,
    PersonaTypeFromJSONTyped,
    PersonaTypeToJSON,
    PersonaTypeToJSONTyped,
} from './PersonaType';

/**
 * 
 * @export
 * @interface CreatePersonaRequest
 */
export interface CreatePersonaRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePersonaRequest
     */
    userId?: string | null;
    /**
     * 
     * @type {PersonaType}
     * @memberof CreatePersonaRequest
     */
    personaType: PersonaType;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePersonaRequest
     */
    labels?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonaRequest
     */
    demographic: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePersonaRequest
     */
    regionId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePersonaRequest
     */
    deviceInfoId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePersonaRequest
     */
    proxyId?: number | null;
}



/**
 * Check if a given object implements the CreatePersonaRequest interface.
 */
export function instanceOfCreatePersonaRequest(value: object): value is CreatePersonaRequest {
    if (!('personaType' in value) || value['personaType'] === undefined) return false;
    if (!('demographic' in value) || value['demographic'] === undefined) return false;
    return true;
}

export function CreatePersonaRequestFromJSON(json: any): CreatePersonaRequest {
    return CreatePersonaRequestFromJSONTyped(json, false);
}

export function CreatePersonaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePersonaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'personaType': PersonaTypeFromJSON(json['persona_type']),
        'labels': json['labels'] == null ? undefined : json['labels'],
        'demographic': json['demographic'],
        'regionId': json['region_id'] == null ? undefined : json['region_id'],
        'deviceInfoId': json['device_info_id'] == null ? undefined : json['device_info_id'],
        'proxyId': json['proxy_id'] == null ? undefined : json['proxy_id'],
    };
}

export function CreatePersonaRequestToJSON(json: any): CreatePersonaRequest {
    return CreatePersonaRequestToJSONTyped(json, false);
}

export function CreatePersonaRequestToJSONTyped(value?: CreatePersonaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'persona_type': PersonaTypeToJSON(value['personaType']),
        'labels': value['labels'],
        'demographic': value['demographic'],
        'region_id': value['regionId'],
        'device_info_id': value['deviceInfoId'],
        'proxy_id': value['proxyId'],
    };
}

